export const PermissionConstants = {
  User_List: "User_List",
  Calendar: "Calendar",
};
